// Select custom (accessibilité basique)
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-select]').forEach(root => {
        const trigger = root.querySelector('.select__trigger');
        const menu = root.querySelector('.select__menu');
        const valueEl = root.querySelector('.select__value');
        const input = root.querySelector('input[type="hidden"]');

        function open()  { root.classList.add('is-open');  trigger?.setAttribute('aria-expanded', 'true'); }
        function close() { root.classList.remove('is-open'); trigger?.setAttribute('aria-expanded', 'false'); }

        trigger?.addEventListener('click', () => {
            root.classList.contains('is-open') ? close() : open();
        });

        menu?.addEventListener('click', (e) => {
            const opt = e.target.closest('.select__option');
            if (!opt) return;
            const val = opt.getAttribute('data-value') ?? opt.textContent.trim();
            if (input)   input.value = val;
            if (valueEl) valueEl.textContent = opt.textContent.trim();
            menu.querySelectorAll('.select__option[aria-selected]')
                .forEach(o => o.setAttribute('aria-selected', String(o === opt)));
            close();
        });

        document.addEventListener('click', (e) => {
            if (!root.contains(e.target)) close();
        });
    });
});
